const imageKey = "tempImage";
const cidKey = "tempConcertId";
const posKey = "tempPos";
const textKey = "tempText";
import store from "../store/index";
import * as types from "../store/modules/history/types.js";

export default class DrawingStorage {
  constructor(concertId, numHistory = 5, namespace = "") {
    this.namespace = namespace;
    this.concertId = concertId;
    this.numHistory = numHistory;
    // 最初にconcertIdのがあれば消す。
    // 不要なやつも消したい
    // 一番最初のやつは真っ白にしたい
    // 戻れなくなったら真っ白にはしない

    this.list = [];
    this.index = 0;
    this.updateStore();
  }
  add(base64) {
    if (this.index == this.list.length - 1) this.normalAdd(base64);
    else this.spliceAdd(base64);

    if (this.list.length > this.numHistory)
      this.list = this.list.slice(this.list.length - this.numHistory);
    this.index = this.list.length - 1;

    this.updateStore();
  }
  normalAdd(base64) {
    this.list.push(base64);
  }

  spliceAdd(base64) {
    this.list = this.list.slice(0, this.index + 1);
    this.list.push(base64);
  }

  back() {
    if (this.index <= 0) {
      this.index = 0;
      return null;
    }
    this.index--;
    this.updateStore();
    return this.getCurrent();
  }
  forward() {
    if (this.index >= this.list.length - 1) {
      this.index = this.list.length - 1;
      return null;
    }
    this.index++;
    this.updateStore();
    return this.getCurrent();
  }

  updateStore() {
    store.dispatch(types.namespace + types.SET_INDEX, this.index);
    store.dispatch(types.namespace + types.SET_LENGTH, this.list.length);
  }

  /**
   * 一時保存する
   * @param base64
   * @param position
   */
  save(base64, position, texts) {
    // if (this.list.length > 0)
    //   localStorage.setItem(namespace + this.concertId, this.list[this.index]);
    localStorage.setItem(imageKey, base64);
    localStorage.setItem(cidKey, this.concertId);
    localStorage.setItem(
      posKey,
      JSON.stringify({ x: position.x, y: position.y })
    );
    if (texts)
      localStorage.setItem(textKey, JSON.stringify(texts));

    // ↓ localstorageあふれるテスト
    // alert('save')
    // let i = 0;
    // try {
    //   for (; i < 50; i++) {
    //     localStorage.setItem(namespace + this.concertId + i, base64);
    //   }
    // } catch (e) {
    //   alert(i);
    //   alert(e);
    // }
  }

  /**
   *
   * @returns {img: string, pos: string}
   */
  load() {
    let item = localStorage.getItem(imageKey);

    if (!item) return null;
    this.list = [item];
    this.index = 1;
    let pos = localStorage.getItem(posKey);
    let texts = localStorage.getItem(textKey);
    try {
      pos = JSON.parse(pos);
      texts = JSON.parse(texts)
    } catch (e) {
      console.log("local storage load pos error", e);
    }
    return { img: item, pos: pos, texts: texts };
  }

  /**
   * 一時保存してたテキストはAPI.SendMessage後に消す
   */
  static removeTemp() {
    localStorage.removeItem(textKey);
    localStorage.removeItem(posKey);
  }

  /**
   * 他のコンサートIDの一時保存画像があるかどうか
   * @param concertId
   * @returns {boolean}
   */
  static hasOtherTmpImage(concertId) {
    let item = localStorage.getItem(cidKey);
    if (!item) return false;
    return item != concertId && localStorage.getItem(imageKey);
  }

  /**
   * 指定したコンサートIDの一時保存画像があるかどうか
   * @param concertId
   * @returns {boolean|string}
   */
  static hasTmpImage(concertId) {
    return (
      localStorage.getItem(cidKey) == concertId &&
      localStorage.getItem(imageKey)
    );
  }

  /**
   * 一時保存を全部すてる
   */
  // deleteAll() {
  //   for (let key in localStorage) {
  //     console.log("key", key);
  //     if (key.indexOf(namespace) > -1) {
  //       localStorage.removeItem(key);
  //     }
  //   }
  // }

  /**
   * ストレージのみを消す
   */
  clearStorage() {
    localStorage.removeItem(imageKey);
    localStorage.removeItem(cidKey);
  }

  /**
   * メモリ内もLocalStorageも両方消す
   */
  clear() {
    this.clearStorage();
    this.clearMemory();
    this.updateStore();
  }

  getLength() {
    return this.list.length;
  }

  /**
   * listを消す。localstorageは消さない。どっかのタイミングで消し去らないと死なない。
   */
  clearMemory() {
    this.list = [];
    this.index = 0;
  }

  getCurrent() {
    let item = this.list[this.index];
    return item;
  }
}
